/* eslint-disable @typescript-eslint/naming-convention */
/*
 * PaymentsService is responsible to handle payment endpoints as well as payment provider logic.
 */

import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  constructor(private httpService: HttpService) {}

  /*
   * Create a rest payment intent on api.
   */
  public post(client_code: string): Promise<any> {
    return this.httpService
      .post('/payments', {
        client_code
      })
      .pipe(
        map((response: any) => {
          return response.data;
        })
      )
      .toPromise();
  }

  /*
   * Update payment intent on api and add rest payment.
   */
  public put(client_code: string): Promise<any> {
    return this.httpService
      .put('/payments', {
        client_code
      })
      .pipe(
        map((response: any) => {
          return response.data;
        })
      )
      .toPromise();
  }

  /*
   * Create payment intent on Api during checkout and return client secret.
   */
  public postPaymentIntent(client: string, amount: number): Promise<any> {
    return this.httpService
      .post('/payments/intent', {
        client,
        amount
      })
      .pipe(
        map((response: any) => {
          return response.data;
        })
      )
      .toPromise();
  }
}
